import React, { useEffect, useState } from "react";
import { Row, Col, Card, Form } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { branchlist } from "../../../services/master";
import { getrestrictions, settinglist } from "../../../services/setting";
import {
    allliststaff,
    groupcreate,
    groupdetail,
    groupmemberlist,
} from "../../../services/admin";
import { AgGridReact } from "ag-grid-react";

export default function Addgroup() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [urllink, setUrllink] = useState("");

    const [grpid, setGrpId] = useState("");
    const [grpname, setGrpName] = useState("");
    const [totmem, setTotMem] = useState(0);
    const [dueon, setDueOn] = useState("");
    // Frequencies enabled in Settings. Defaults to all three so the dropdown is
    // never empty if the call fails; the API is the real gate.
    const [allowedfreq, setAllowedFreq] = useState(["Daily", "Weekly", "Monthly"]);
    const [maxmembers, setMaxMembers] = useState(null);
    const [collday, setCollDay] = useState("");
    const [slist, setSlist] = useState([]);
    const [collstaff, setCollStaff] = useState("");
    const [branch, setBranch] = useState("");
    const [blist, setBlist] = useState([]);
    const [collcenter, setCollCenter] = useState("");
    const [grpact, setGrpAct] = useState("");
    const [gstatus, setGStatus] = useState("1");
    const [gtime, setGTime] = useState("");

    const [mlist, setMlist] = useState([]);

    const location = useLocation();

    const columnDefs = [
        {
            headerName: "Actions",
            field: "id",
            width: 120,
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <a
                            className="btn-sm btn-info me-2"
                            onClick={() => navigate(`/member/groupmemberdetail/${params.value}/${id}`)}
                        >
                            <i className="fa fa-edit"></i>
                        </a>
                        <a
                            className="btn-sm btn-success me-2"
                            onClick={() => navigate(`/member/groupmemberprofile/${params.value}/${id}`)}
                        >
                            <i className="fa fa-user"></i>
                        </a>
                       
                    </div>
                );
            },
        },
        {
            headerName: "Member",
            field: "member_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Phone",
            field: "phone_no",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },

        {
            headerName: "Native",
            field: "native_place",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Group Name",
            field: "group_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Branch",
            field: "branch_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
    ];

    // Frequencies and the member cap are set per branch, so re-read them
    // whenever the branch changes — the API checks the group against the branch
    // it is being saved into, and the form has to agree.
    useEffect(() => {
        // Before a branch is picked, show the rules for the one the user is
        // working in (getrestrictions' own default) rather than nothing.
        getrestrictions(branch === "" ? undefined : branch).then((res) => {
            if (res?.status === true) {
                setAllowedFreq(res.data?.allowed_frequencies || []);
                setMaxMembers(res.data?.details?.max_members_per_group ?? null);
            }
        });
    }, [branch]);

    useEffect(() => {
        const path = location.pathname.split("/")[2];
        setUrllink(path);

        branchlist().then((res) => {
            if (res.status === true) {
                const userBranches = localStorage.getItem("branch")
                const filteredBranches = res.data.filter(branch => userBranches.includes(branch.id));
                setBlist(filteredBranches);
                // setBlist(res.data);
            }
        });
        allliststaff(localStorage.getItem("branch")).then((res) => {
            if (res.status === true) {
                setSlist(res.data.details);
            }
        });

        if (path === "groupdetail") {
            groupdetail(id).then((res) => {
                if (res.status === true) {
                    setGrpId(res.data.group_id);
                    if (res.data.group_name !== null) {
                        setGrpName(res.data.group_name);
                    }
                    if (res.data.total_members !== null) {
                        setTotMem(res.data.total_members);
                    }
                    if (res.data.group_due !== null) {
                        setDueOn(res.data.group_due);
                    }
                    if (res.data.group_collection_day !== null) {
                        setCollDay(res.data.group_collection_day);
                    }
                    if (res.data.group_collection_staff !== null) {
                        setCollStaff(res.data.group_collection_staff);
                    }
                    if (res.data.group_branch !== null) {
                        setBranch(res.data.group_branch);
                    }
                    if (res.data.group_center !== null) {
                        setCollCenter(res.data.group_center);
                    }
                    if (res.data.active !== null) {
                        setGStatus(res.data.active);
                    }
                    if (res.data.group_time !== null) {
                        setGTime(res.data.group_time);
                    }
                }
            });

            groupmemberlist(id).then((res) => {
                if (res.status === true) {
                    setMlist(res.data);
                }
            });
        } else {
            setGrpName("");
            setTotMem("");
            setDueOn("");
            setCollDay("");
            setCollStaff("");
            setBranch("");
            setCollCenter("");
            setGTime("");
            setGStatus("1");
            settinglist().then((res) => {
                if (res.status === true) {
                    if (res.data !== null) {
                        setGrpId(res.data.group_id);
                        setGrpAct(res.data.group);
                    }
                }
            });
        }
    }, [location.pathname]);

    const handleMem = (e) => {
        const regex = /^[0-9\b]+$/;
        if (e.target.value === "" || regex.test(e.target.value)) {
            setTotMem(e.target.value);
        }
    };
    const [psubmit, setPsubmit] = useState(false);
    const [perror, setPerror] = useState("");
    function handlesubmit(e) {
        e.preventDefault();
        setPerror("");
        setPsubmit(true);
        if (
            grpid !== "" &&
            grpname !== "" &&
            // totmem !== "" &&
            dueon !== "" &&
            // collday !== "" &&
            collstaff !== "" &&
            branch !== ""
            //  &&
            // collcenter !== "" &&
            // gtime !== ""
        ) {
            setLoading(true);
            setPsubmit(false);
            const temp = new FormData();
            temp.append("group_id", grpid);
            temp.append("group_name", grpname);
            temp.append("total_members", totmem);
            temp.append("group_due", dueon);
            temp.append("group_collection_day", collday);
            temp.append("group_collection_staff", collstaff);
            temp.append("group_branch", branch);
            temp.append("group_center", collcenter);
            temp.append("group_time", gtime);
            temp.append("active", gstatus);
            if (urllink === "groupdetail") {
                temp.append("id", id);
            }
            groupcreate(temp).then((res) => {
                if (res.status === true) {
                    setLoading(false);
                    toast.success(res.message);
                    navigate("/group/allgroup");
                } else {
                    setLoading(false);
                    setPerror(res.message);
                }
            });
        }
    }

    const [loading, setLoading] = useState(false);

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">
                    {urllink === "groupdetail" ? "Group Detail" : "Add Group"}
                </h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Group</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        {urllink === "groupdetail" ? "Group Detail" : "Add Group"}
                    </li>
                </ol>
            </div>
            {loading && (
                <div className="loader-wrapper">
                    <div className="loader"></div>
                    <h3>Loading...Please do not go back or close the window.</h3>
                </div>
            )}
            {!loading && (
                <div className="content-body">
                    <Row>
                        <Col xl={12}>
                            <Card>
                                <Card.Header>
                                    <h2 className="main-content-title tx-24 mg-b-5">
                                        {urllink === "groupdetail" ? "Group Detail" : "Add Group"}
                                    </h2>
                                </Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col xl={4} sm={6}>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Group ID <span className="text-danger"> *</span>
                                                </label>
                                                {grpact === "Automatic" && urllink === "addgroup" && (
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Group Id"
                                                        value={grpid}
                                                        onChange={(e) => setGrpId(e.target.value)}
                                                        disabled
                                                    />
                                                )}
                                                {grpact !== "Automatic" && urllink === "addgroup" && (
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Group Id"
                                                        value={grpid}
                                                        onChange={(e) => setGrpId(e.target.value)}
                                                    />
                                                )}

                                                {urllink === "groupdetail" && (
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Group Id"
                                                        value={grpid}
                                                        onChange={(e) => setGrpId(e.target.value)}
                                                        disabled
                                                    />
                                                )}
                                                {psubmit && grpid === "" && (
                                                    <span className="text-danger">
                                                        Group Id is required
                                                    </span>
                                                )}
                                            </div>
                                        </Col>
                                        <Col xl={4} sm={6}>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Group Name <span className="text-danger"> *</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Group Name"
                                                    value={grpname}
                                                    onChange={(e) => setGrpName(e.target.value)}
                                                />
                                                {psubmit && grpname === "" && (
                                                    <span className="text-danger">
                                                        Group Name is required
                                                    </span>
                                                )}
                                            </div>
                                        </Col>
                                        {/* <Col xl={4} sm={6}>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Total Members <span className="text-danger"> *</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Total Memebers"
                                                    value={totmem}
                                                    onChange={handleMem}
                                                />
                                                {maxmembers > 0 && (
                                                    <small className="text-muted">
                                                        Settings allow up to {maxmembers} members per
                                                        group.
                                                    </small>
                                                )}
                                                {psubmit && totmem === "" && (
                                                    <span className="text-danger">
                                                        Total Memebers is required
                                                    </span>
                                                )}
                                            </div>
                                        </Col> */}

                                        <Col xl={4} sm={6}>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Due On<span className="text-danger"> *</span>
                                                </label>
                                                <select
                                                    className="default-select  form-control wide"
                                                    value={dueon}
                                                    onChange={(e) => setDueOn(e.target.value)}
                                                >
                                                    <option value="" disabled>
                                                        Select Due On
                                                    </option>
                                                    {/* Only frequencies enabled in Settings; the API
                                                        rejects the rest anyway. An already-saved group
                                                        keeps its own value visible. */}
                                                    {allowedfreq.map((f) => (
                                                        <option value={f} key={f}>
                                                            {f}
                                                        </option>
                                                    ))}
                                                    {dueon !== "" && !allowedfreq.includes(dueon) && (
                                                        <option value={dueon}>{dueon} (disabled)</option>
                                                    )}
                                                </select>
                                                {psubmit && dueon === "" && (
                                                    <span className="text-danger">
                                                        Due On is required
                                                    </span>
                                                )}
                                            </div>
                                        </Col>
                                        {/* <Col xl={4} sm={6}>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Collection Day
                                                    <span className="text-danger"> *</span>
                                                </label>
                                                <select
                                                    className="default-select  form-control wide"
                                                    value={collday}
                                                    onChange={(e) => setCollDay(e.target.value)}
                                                >
                                                    <option value="" disabled>
                                                        Select Collection Day
                                                    </option>
                                                    <option value="Monday">Monday</option>
                                                    <option value="Tuesday">Tuesday</option>
                                                    <option value="Wednesday">Wednesday</option>
                                                    <option value="Thursday">Thursday</option>
                                                    <option value="Friday">Friday</option>
                                                    <option value="Saturday">Saturday</option>
                                                    <option value="Sunday">Sunday</option>
                                                </select>
                                                {psubmit && collday === "" && (
                                                    <span className="text-danger">
                                                        Collection Day is required
                                                    </span>
                                                )}
                                            </div>
                                        </Col> */}
                                        <Col xl={4} sm={6}>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Collection Staff
                                                    <span className="text-danger"> *</span>
                                                </label>
                                                <select
                                                    className="default-select  form-control wide"
                                                    value={collstaff}
                                                    onChange={(e) => setCollStaff(e.target.value)}
                                                >
                                                    <option value="" disabled>
                                                        Select Collection Staff
                                                    </option>
                                                    {slist.map((item, index) => {
                                                        return (
                                                            <option
                                                                value={item.id}
                                                                key={index}
                                                                className={
                                                                    item.active === 0 ? "text-danger" : ""
                                                                }
                                                                disabled={item.active === 0}
                                                            >
                                                                {item.staff_name}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                                {psubmit && collstaff === "" && (
                                                    <span className="text-danger">
                                                        Collection Staff is required
                                                    </span>
                                                )}
                                            </div>
                                        </Col>
                                        <Col xl={4} sm={6}>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Branch<span className="text-danger"> *</span>
                                                </label>
                                                <select
                                                    className="default-select  form-control wide"
                                                    value={branch}
                                                    onChange={(e) => setBranch(e.target.value)}
                                                >
                                                    <option value="" disabled>
                                                        Select Branch
                                                    </option>
                                                    {blist.map((item, index) => {
                                                        return (
                                                            <option key={index} value={item.id}>
                                                                {item.branch_name}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                                {psubmit && branch === "" && (
                                                    <span className="text-danger">
                                                        Branch is required
                                                    </span>
                                                )}
                                            </div>
                                        </Col>
                                        <Col xl={4} sm={6}>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Collection Center
                                                    {/* <span className="text-danger"> *</span> */}
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Collection Center"
                                                    value={collcenter}
                                                    onChange={(e) => setCollCenter(e.target.value)}
                                                />
                                                {/* {psubmit && collcenter === "" && (
                                                    <span className="text-danger">
                                                        Collection Center is required
                                                    </span>
                                                )} */}
                                            </div>
                                        </Col>
                                        <Col xl={4} sm={6}>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Collection Time
                                                    {/* <span className="text-danger"> *</span> */}
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Collection Time"
                                                    value={gtime}
                                                    onChange={(e) => setGTime(e.target.value)}
                                                />
                                                {/* {psubmit && gtime === "" && (
                                                    <span className="text-danger">
                                                        Collection Time is required
                                                    </span>
                                                )} */}
                                            </div>
                                        </Col>
                                       
                                        <Col xl={4} sm={6}>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Status<span className="text-danger"> *</span>
                                                </label>
                                                <select
                                                    className="default-select  form-control wide"
                                                    value={gstatus}
                                                    onChange={(e) => setGStatus(e.target.value)}
                                                >
                                                    <option value="" disabled>
                                                        Select Status
                                                    </option>
                                                    <option value="1">Active</option>
                                                    <option value="0">In-Active</option>
                                                </select>
                                                {psubmit && gstatus === "" && (
                                                    <span className="text-danger">
                                                        Status is required
                                                    </span>
                                                )}
                                            </div>
                                        </Col>
                                        {perror && <span className="text-danger">{perror}</span>}
                                    </Row>
                                    <div className="text-end">
                                        <a className="btn btn-success me-2" onClick={handlesubmit}>
                                            Submit
                                        </a>
                                        {urllink === "groupdetail" &&
                                            <a className="btn btn-secondary" onClick={()=>navigate("/group/allgroup")}>
                                            Back
                                        </a>
                                        }
                                    </div>
                                </Card.Body>
                                {mlist.length > 0 && urllink === "groupdetail" &&
                                    <>
                                        <Card.Header>
                                            <h2 className="main-content-title tx-24 mg-b-5">
                                                Group Members
                                            </h2>
                                        </Card.Header>
                                        <Card.Body>
                                            <div className="ag-theme-alpine ag-style mt-2">
                                                <AgGridReact
                                                    columnDefs={columnDefs}
                                                    rowData={mlist}
                                                    pagination="true"
                                                    paginationPageSize="10"
                                                    sortingOrder={["asc", "desc"]}
                                                    suppressDragLeaveHidesColumns={true}
                                                />
                                            </div>
                                        </Card.Body>
                                    </>
                                }

                            </Card>
                        </Col>
                    </Row>
                </div>
            )}
        </div>
    );
}
